import { render } from "./BMReceivedParcels.vue?vue&type=template&id=fd4f8656&scoped=true"
import script from "./BMReceivedParcels.vue?vue&type=script&lang=js"
export * from "./BMReceivedParcels.vue?vue&type=script&lang=js"

import "./BMReceivedParcels.vue?vue&type=style&index=0&id=fd4f8656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd4f8656"]])

export default __exports__